"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.RED_COLOR = exports.ACTION_BTN = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    ACTION_BTN = (0, _cxs["default"])({
  display: "flex",
  alignItems: "center",
  border: "none",
  minHeight: "45px",
  width: "200px",
  padding: "10px 20px",
  boxSizing: "border-box",
  position: "relative",
  ":hover:after": {
    content: "\"\"",
    background: _vars.COLOURS.cyan.jungleGreen.monkeyLight,
    position: "absolute",
    left: "10px",
    top: "5px",
    width: "calc(100% - 20px)",
    minHeight: "calc(100% - 10px)",
    zIndex: -1,
    borderRadius: "8px"
  }
});

exports.ACTION_BTN = ACTION_BTN;
var RED_COLOR = (0, _cxs["default"])({
  color: "".concat(_vars.COLOURS.red.redApple, " !important")
});
exports.RED_COLOR = RED_COLOR;